import { useSelector } from 'react-redux';
import { IStore } from '../../../../../store/interface';
import { getShopIdentifiers } from '../../selectors';

export const useShopIdentifiers = () => ({
  identifiers: useSelector<IStore, number>(getShopIdentifiers),
});
